// IE 2026 10 13 / ODOO-5800 (бот на проде 13.10, отчёт «Сигнали», виджет 1Nk0_001): у полосы чипсов над таблицей (AttrChips, mode 'Embedded') вкладка «Chips» панели ⌄
// несла только предложения (Parent / Metrics / Formats) — чипсы самого виджета, выключенные (meta.use = false: «Resolved», «Mine»), не были перечислены нигде, включить
// их пользователю было нечем. Теперь вкладка «Chips» (вкладка без meta.name) перечисляет чипсы виджета ПЕРВЫМИ (вкл. выключенные — флажок check_chip_dropdown + emitChips),
// за ними — прежние предложения. Есть вкладка 'filters' (Standalone / Page / Legacy, она уже несёт this.chips) — список не дублируется.
// Флаг fe.ux.chipsListAllModes (дефолт ВКЛ); выкл — как было. Чистая логика — юнит tests/unit/chipsList.test.mjs
export const CHIPS_LIST_FLAG = 'fe.ux.chipsListAllModes'   // IE 2026 10 13 / ODOO-5800

export function chipsList_on(setting) {   // IE 2026 10 13 / ODOO-5800: чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(CHIPS_LIST_FLAG, true) !== false : true } catch (e) { return true }
}

// есть ли среди вкладок панели ⌄ вкладка 'filters' (она уже перечисляет чипсы виджета)
export function chipsTabs_hasFilters(tabs) {   // IE 2026 10 13 / ODOO-5800
    return Array.isArray(tabs) && tabs.some(t => t && typeof t === 'object' && t.meta?.name === 'filters')
}

// пункты вкладки «Chips»: чипсы виджета (без виртуальных полосы — Limit / зеркало / черновик), затем предложения; флаг выкл / есть вкладка 'filters' — только предложения
export function chipsTab_attrs(chips, offers, { on = true, hasFilters = false } = {}) {   // IE 2026 10 13 / ODOO-5800
    const tail = Array.isArray(offers) ? offers : []
    if (!on || hasFilters || !Array.isArray(chips)) return tail
    const own = chips.filter(c => c && typeof c === 'object' && !c._isVirtual && !c._template)
    return own.length ? [...own, ...tail] : tail
}
